// @flow
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './styles'

export const getContactEmailAddresses = (contact) => {
  if (Array.isArray(contact.emails) && contact.emails.length > 0) {
    return contact.emails.map((item) => (typeof item === 'string' ? item : item && item.email)).filter(Boolean)
  }
  return contact.email ? [contact.email] : []
}

const copyEmailToClipboard = (value) => {
  if (!value) return null
  return navigator.clipboard.writeText(value)
}

const EmailActions = ({ address, emailKey, copiedEmailKey, onCopy }) => {
  const handleSendEmail = () => {
    window.location.href = `mailto:${address}`
  }
  return (
    <tr>
      <td style={{ paddingRight: 8, paddingBottom: 6, verticalAlign: 'middle' }}>
        <span className={styles.contactEmailText}>{address}</span>
      </td>
      <td style={{ width: 38, paddingRight: 6, paddingBottom: 6, verticalAlign: 'middle' }}>
        <button className={styles.contactEmailActionButton} onClick={() => onCopy(address, emailKey)} title="Copy email" type="button">
          <FontAwesomeIcon icon={copiedEmailKey === emailKey ? ['fas', 'check'] : ['far', 'copy']} />
        </button>
      </td>
      <td style={{ width: 38, paddingBottom: 6, verticalAlign: 'middle' }}>
        <button className={styles.contactEmailActionButton} onClick={handleSendEmail} title="Send email" type="button">
          <FontAwesomeIcon icon={['far', 'paper-plane']} />
        </button>
      </td>
    </tr>
  )
}

const EmailActionsList = ({ contact }) => {
  const [copiedEmailKey, setCopiedEmailKey] = React.useState(null)
  const timeoutRef = React.useRef(null)
  const addresses = getContactEmailAddresses(contact)

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  const onCopy = (address, emailKey) => {
    const copyPromise = copyEmailToClipboard(address)
    if (!copyPromise) return
    copyPromise.then(() => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      setCopiedEmailKey(emailKey)
      timeoutRef.current = setTimeout(() => setCopiedEmailKey(null), 1200)
    })
  }

  if (!addresses.length) return <span>N/A</span>

  return (
    <table style={{ borderCollapse: 'collapse', margin: 0, padding: 0 }}>
      <tbody>
        {addresses.map((address, index) => {
          const emailKey = `${address}-${index}`
          return <EmailActions key={emailKey} address={address} copiedEmailKey={copiedEmailKey} emailKey={emailKey} onCopy={onCopy} />
        })}
      </tbody>
    </table>
  )
}

export default EmailActionsList
